const basePath = '/customer-portal';

export const customerPortalRoutes = {
  root: basePath,
  purchaseOrders: `${basePath}/purchase-orders`,
  purchaseOrderDetails: `${basePath}/purchase-orders/:purchaseOrderId`,
  purchaseOrderCounterpartySO: `${basePath}/purchase-orders/:purchaseOrderId/counterparty-so`,
  bookings: `${basePath}/bookings`,
  bookingDetails: `${basePath}/bookings/:bookingId`,
  loads: `${basePath}/loads`,
  loadDetails: `${basePath}/loads/:loadId`,
  bills: `${basePath}/bills`,
} as const;
